import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function NikoFacilityOrderNewFlowInventoryCalculationProcessModalTemplate({ nikoFacilityOrderNewFlowInventoryCalculationProcessModalStore, t }) {
    const {
        processInventory,
        isLoading,
        modalParams
    } = nikoFacilityOrderNewFlowInventoryCalculationProcessModalStore;

    return (
        <section>
            <div className={!modalParams.data.approvalRequired ? 'modal__body type--center' : 'modal__wrap'}>
                <i className="status--sqare modal-warning u-mar--bottom--med u-radius--full" />
                <h3 className='modal__header__title'>{!modalParams.data.approvalRequired ? 'This action cannot be undone, all sales orders will be edited.' : 'This facility requires approval to send extra supplies. Was approval received?'}</h3>

                {modalParams.data.approvalRequired && 
                    <p className='type--base u-padd--right--med u-mar--top--med type--color--secondary'>
                        {t('MODAL.PROCESS_MESSAGE_APPROVAL')}
                    </p>
                }
            </div>
            
            <div className={!modalParams.data.approvalRequired ? 'modal__footer' : 'modal__footer is-right'}>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    disabled={isLoading}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={!modalParams.data.approvalRequired ? "Process / Finish" : "Yes, Process Inventory"}
                    disabled={isLoading}
                    onClick={() => processInventory()}
                    rotate icon={
                        isLoading
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

NikoFacilityOrderNewFlowInventoryCalculationProcessModalTemplate.propTypes = {
    nikoFacilityOrderNewFlowInventoryCalculationProcessModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderNewFlowInventoryCalculationProcessModalTemplate);
